import React, { useContext, useState } from "react";

// primereact components
import { Button } from "primereact/button";

// context
import { useSendStation } from "../../../../../../context/SendStationContext";
import { ToastContext } from "../../../../../../App";

// services
import { generateReportFile } from "../../services/generateReportFile";
import { sendReportEmail } from "../../services/sendReportEmail";

// styles
import * as styles from "./SendStationModalFooter.module.css";

export const SendStationModalFooter = ({ statRef }) => {
  const [isSending, setIsSending] = useState(false);
  const showToast = useContext(ToastContext);
  const {
    currentStation,
    email,
    setEmailEditable,
    reportFormat,
    setSendEmailModalOpen,
    isEmailValid,
  } = useSendStation();

  const handleSend = async () => {
    try {
      setIsSending(true);
      setEmailEditable(false);

      const file = await generateReportFile({
        currentStation,
        reportFormat,
        statRef,
      });

      await sendReportEmail({
        email,
        file,
        reportFormat,
        stationName: currentStation?.name || "Station",
      });

      showToast(
        "success",
        "Email sent",
        "The report has been successfully sent",
      );

      setSendEmailModalOpen(false);
    } catch (error) {
      console.error(error);
      showToast(
        "error",
        "Sending failed",
        error.message || "Unable to send report",
      );
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className={styles.actions}>
      <Button
        label="Send"
        className={styles.sendButton}
        disabled={!isEmailValid || isSending}
        loading={isSending}
        onClick={handleSend}
      />

      <Button
        label="Cancel"
        className={styles.cancelButton}
        onClick={() => setSendEmailModalOpen(false)}
      />
    </div>
  );
};
